import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/store/modules/User'
import general from '@/store/modules/General'
import products from '@/store/modules/Products'
import order from '@/store/modules/Order'
import preorder from '@/store/modules/Preorder'
import errors from '@/store/modules/Errors'
import nfc from '@/store/modules/Nfc'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    general,
    products,
    order,
    preorder,
    errors,
    nfc
  },
  strict: process.env.NODE_ENV !== 'production'
})

export default store
